var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 28.5,
    fill: "white",
    stroke: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_86_134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.4878 14H14.5122C12.5725 14 11 15.5743 11 17.5164V36.1127C11 38.0548 12.5725 39.6291 14.5122 39.6291H43.4878C45.4275 39.6291 47 38.0548 47 36.1127V17.5164C47 15.5743 45.4275 14 43.4878 14Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4878 15.623H14.5122C13.505 15.623 12.6885 16.4405 12.6885 17.4489V36.1128C12.6885 37.1212 13.505 37.9386 14.5122 37.9386H43.4878C44.495 37.9386 45.3114 37.1212 45.3114 36.1128V17.4489C45.3114 16.4405 44.495 15.623 43.4878 15.623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0469 38.8176H27.818V42.5369H30.0469V38.8176Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5419 41.7624C29.0317 41.4178 28.339 41.5526 27.9948 42.0635C27.6507 42.5744 27.7853 43.2679 28.2956 43.6125L32.923 46.7374C33.4333 47.082 34.1259 46.9472 34.4701 46.4363C34.8143 45.9255 34.6796 45.232 34.1694 44.8874L29.5419 41.7624Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5092 43.6273C30.0194 43.2827 30.1541 42.5892 29.8099 42.0783C29.4657 41.5675 28.7731 41.4327 28.2628 41.7773L23.6354 44.9022C23.1251 45.2468 22.9904 45.9403 23.3346 46.4512C23.6788 46.9621 24.3715 47.0969 24.8817 46.7523L29.5092 43.6273Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_86_134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 33,
    fill: "white",
    transform: "translate(11 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.55c8265cf1b0fe2a5fcec3504bb2f5fa.svg";
export { ForwardRef as ReactComponent };